<!--
    file type .....: HTML file: agencies.component.html
    Created By ....: ianday
    Date ..........: 9/27/23 
-->
<script src="agencies.component.ts"></script>
<mat-drawer-container class="mat-elevation-z2 agencies-container">
    <mat-drawer disableClose="true" mode="side" opened style="width:168px;">
        <mat-action-list>
			<span>
			  <button id="agencyDefId" class="button-menu" *ngIf="visibleAgencyDefinitionLink"
                      matTooltipPosition="right"
                      matTooltip="Manage Agency Information"
                      mat-list-item (click)="showAgencyDefinition()"> Agency Details
              </button>
			</span>

            <hr style="width: 90%" />

            <span>
			  <button id="serviceDefId" class="button-menu" *ngIf="visibleServiceDefinitionLink"
                      matTooltipPosition="right"
                      matTooltip="Manage Service Definitions"
                      mat-list-item (click)="showServiceDefinition()" > Service Definitions
              </button>
            </span>
            
              <span>
			  <button id="customQualificationId" class="button-menu" *ngIf="visibleCustomQualificationsLink"
                      matTooltipPosition="right"
                      matTooltip="Manage Custom Qualifications"
                      mat-list-item (click)="showCustomQualifications()" > Qualifications
              </button>
            </span>
            
             <span>
			  <button id="emailSuffixesId" class="button-menu" *ngIf="visibleMessageSuffixesLink"
                      matTooltipPosition="right"
                      matTooltip="Manage Email Suffixes for diffrent request statuses"
                      mat-list-item (click)="showMessageSuffixes()" > Message Suffixes
              </button>
            </span>

            <span>
			  <button id="serviceSummaryId" class="button-menu" *ngIf="visibleServiceSummaryLink"
                      matTooltipPosition="right"
                      matTooltip="View Service Summary Information"
                      mat-list-item (click)="showServiceSummary()"> Service Summary
              </button>
			</span>
        </mat-action-list>
    </mat-drawer>

    <mat-drawer-content class="mat-drawer-content-container" style="overflow:hidden!important;">
        <app-agencydefinition *ngIf="visibleAgencyDefinition===true" ></app-agencydefinition>
        <app-servicesummary *ngIf="visibleServiceSummary===true"> </app-servicesummary>
        <app-servicedefinition *ngIf="visibleServiceDefinition===true"> </app-servicedefinition>
        <app-custom-qualifications *ngIf="visibleCustomQualifications===true"> </app-custom-qualifications>
        <app-message-suffixes *ngIf="visibleMessageSuffixes===true"> </app-message-suffixes>
    </mat-drawer-content>
</mat-drawer-container>
